import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "606fitness_lang";

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) || "ar";
        } catch {
            return "ar";
        }
    });

    useEffect(() => {
        const t = translations[lang] || translations.ar;
        document.documentElement.setAttribute("lang", lang);
        document.documentElement.setAttribute("dir", t.direction);
        try {
            localStorage.setItem(STORAGE_KEY, lang);
        } catch {}
    }, [lang]);

    const setLang = useCallback((next) => setLangState(next), []);
    const toggle = useCallback(
        () => setLangState((l) => (l === "ar" ? "en" : "ar")),
        []
    );

    const t = translations[lang] || translations.ar;
    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx)
        throw new Error("useLang must be used inside <LanguageProvider>");
    return ctx;
};
